import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import HomeBanner from './HomeBanner'

const HomeBannerContainer = ({ isMobile }) => {

    const data = useStaticQuery(graphql`
    {
      allWordpressAcfGatsbyPage {
        nodes {
          acf {
            banner_1_group {
              alt_imagem_1
              link_banner_1 {
                url
              }
              alt_imagem_2
              link_banner_2 {
                url
              }
              alt_imagem_3
              link_banner_3 {
                url
              }
              alt_imagem_4
              link_banner_4 {
                url
              }
              alt_imagem_5
              link_banner_5 {
                url
              }
              imagem_banner_1 {
                localFile {
                  childImageSharp {
                    fluid(quality: 100, maxWidth: 2560) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
              imagem_banner_mobile_1 {
                localFile {
                  childImageSharp {
                    fluid(quality: 100, maxWidth: 767) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
              imagem_banner_2 {
                localFile {
                  childImageSharp {
                    fluid(quality: 100, maxWidth: 2560) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
              imagem_banner_mobile_2 {
                localFile {
                  childImageSharp {
                    fluid(quality: 100, maxWidth: 767) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
              imagem_banner_3 {
                localFile {
                  childImageSharp {
                    fluid(quality: 100, maxWidth: 2560) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
              imagem_banner_mobile_3 {
                localFile {
                  childImageSharp {
                    fluid(quality: 100, maxWidth: 767) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
              imagem_banner_4 {
                localFile {
                  childImageSharp {
                    fluid(quality: 100, maxWidth: 2560) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
              imagem_banner_mobile_4 {
                localFile {
                  childImageSharp {
                    fluid(quality: 100, maxWidth: 767) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
              imagem_banner_5 {
                localFile {
                  childImageSharp {
                    fluid(quality: 100, maxWidth: 2560) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
              imagem_banner_mobile_5 {
                localFile {
                  childImageSharp {
                    fluid(quality: 100, maxWidth: 767) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)
  return <HomeBanner isMobile={isMobile} data={data} />
}

export default HomeBannerContainer
